import { FC, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as auth from '../../auth/redux/AuthRedux';

const PickerLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const intl = useIntl();

  const handleLogout = () => {
    dispatch(auth.actions.logout());
    history.push('/auth/login');
    document.location.reload();
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      <header className="d-flex justify-content-between align-items-center px-4 py-3 bg-white shadow-sm">
        <div className="d-flex align-items-center">
          <img
            src="/media/logos/logo-foodforjoe.png"
            alt="Food for Joe"
            style={{ height: 32 }}
          />
          <span className="ms-3 fw-bold text-muted">
            {intl.formatMessage({ id: 'picking.wms' })}
          </span>
        </div>
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={handleLogout}
        >
          {intl.formatMessage({ id: 'picking.logout' })}
        </button>
      </header>
      <main className="flex-grow-1 d-flex align-items-center justify-content-center p-4">
        {children}
      </main>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover={false}
        draggable={false}
      />
    </div>
  );
};

export { PickerLayout };
